import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { FeatureAggregationService } from '@y42/feature';
import { TriggeredByType, Y42FeatureType } from '@y42/json-schema';
import { map } from 'rxjs/operators';
import { JobUIModel } from '../../../state';

@UntilDestroy()
@Component({
  selector: 'y42-triggered-by-type-renderer',
  templateUrl: './triggered-by-type-cell-renderer.component.html',
  styleUrls: ['./triggered-by-type-cell-renderer.component.scss'],
})
export class TriggeredByTypeCellRendererComponent extends BaseCellRendererComponent<TriggeredByType, JobUIModel> {
  constructor(private readonly featureAggregationService: FeatureAggregationService) {
    super();
  }

  readonly IconSizePx = 20;
  readonly TriggeredByType = TriggeredByType;
  readonly OrchestrationIcon = this.featureAggregationService.getLogoByFeatureType(Y42FeatureType.Orchestration);

  state = connectState(this, {
    valueAsArray: this.valueAsArray$,
    valueAsSingle: this.valueAsSingle$,
    triggeredByUser: this.data$.pipe(
      map((data) => (data?.triggeredBy?.type === TriggeredByType.User ? data.triggeredBy.data : undefined)),
    ),
  });
}
